/** Italian dictionary — source of truth. English keys mirror this structure. */
export const it = {
  common: {
    loading: "Caricamento…",
    saving: "Salvataggio…",
    cancel: "Annulla",
    confirm: "Conferma",
    close: "Chiudi",
    back: "Indietro",
    continue: "Continua",
    retry: "Riprova",
    refresh: "Aggiorna",
    yes: "Sì",
    no: "No",
    optional: "opzionale",
    required: "obbligatorio",
    processing: "Elaborazione…",
    saveFolder: "Salva nella cartella",
    downloadZip: "Scarica ZIP",
    archiveDownloaded: "Archivio scaricato",
    saveCanceled: "Salvataggio annullato",
    page: "Pagina",
    delete: "Elimina",
  },
  nav: {
    dashboard: "Dashboard",
    acroform: "AcroForm",
    csvBatch: "CSV batch",
    editor: "Editor",
    subscribe: "Abbonamento",
    admin: "Super admin",
    logout: "Esci",
    account: "Account",
    tabs: {
      batch: "Batch identico",
      csv: "Da CSV (mail-merge)",
      form: "Campi modulo (AcroForm)",
      admin: "Admin",
    },
  },
  language: {
    label: "Lingua",
    italian: "Italiano",
    english: "English",
  },
  auth: {
    stepLogin: "00 · Accedi",
    stepRegister: "00 · Registrazione",
    stepForgot: "00 · Recupero password",
    stepReset: "00 · Nuova password",
  },
  login: {
    title: "Accedi al tuo account",
    subtitle: "Bentornato. Gestisci modelli, abbonamento e account.",
    emailLabel: "Email",
    passwordLabel: "Password",
    forgot: "Password dimenticata?",
    submit: "Accedi",
    submitting: "Accesso in corso…",
    noAccount: "Non hai un account?",
    toRegister: "Registrati →",
    errorInvalid: "Credenziali non valide",
  },
  register: {
    title: "Crea il tuo account",
    subtitle: "7 giorni gratis, senza carta e senza addebiti automatici.",
    nameLabel: "Nome",
    namePlaceholder: "Mario Rossi",
    emailLabel: "Email",
    emailPlaceholder: "nome@esempio.it",
    passwordLabel: "Password",
    passwordPlaceholder: "minimo 6 caratteri",
    submit: "Inizia la prova gratuita",
    submitting: "Creazione account…",
    footerTagline: "7 giorni gratis, senza carta e senza addebiti automatici.",
    footerDetail: "Nessun pagamento ora. Decidi se abbonarti alla fine della prova.",
    haveAccount: "Hai già un account?",
    toLogin: "Accedi →",
    successTrial: "Account creato. Hai 7 giorni di prova gratuita.",
    successNoTrial: "Account creato. Hai già utilizzato la prova gratuita con questa email.",
  },
  forgot: {
    title: "Recupera la password",
    subtitle: "Inserisci l'email del tuo account.",
    emailLabel: "Email",
    submit: "Invia link di recupero",
    submitting: "Invio…",
    done: "Se l'email è registrata, riceverai le istruzioni a breve.",
    backToLogin: "Torna al login",
  },
  reset: {
    title: "Imposta una nuova password",
    subtitle: "Scegli una password di almeno 6 caratteri.",
    passwordLabel: "Nuova password",
    confirmLabel: "Conferma password",
    submit: "Aggiorna password",
    submitting: "Aggiornamento…",
    mismatch: "Le password non coincidono.",
    tooShort: "La password deve avere almeno 6 caratteri.",
    done: "Password aggiornata. Ora puoi accedere.",
  },
  subscribe: {
    pageTitle: "Abbonamento",
    trialBadge: "Prova gratuita · fino al {date}",
    trialBody: "Puoi utilizzare tutte le funzionalità di REVO PDF Loader fino al {date}. La prova è gratuita, senza carta e senza addebiti automatici. Al termine, per continuare a usare le funzioni PDF dovrai abbonarti.",
    stripeTrialBody: "Puoi utilizzare tutte le funzionalità di REVO PDF Loader fino al {date}. Successivamente partirà l'abbonamento mensile.",
    activeTitle: "Abbonamento attivo",
    activeBody: "Il tuo abbonamento è attivo. Grazie!",
    canceledTitle: "Abbonamento annullato",
    canceledBody: "Il tuo abbonamento è stato annullato. Potrai usare l'app fino al {date}.",
    pastDueTitle: "Pagamento in sospeso",
    pastDueBody: "Il pagamento non è andato a buon fine. Aggiorna il metodo di pagamento per continuare.",
    pricingTitle: "Prova gratuita terminata",
    pricingTitleExpiredTrial: "La tua prova gratuita di 7 giorni è terminata.",
    pricingSub: "Abbonati a €9,90/mese per riprendere subito. Primo addebito oggi, cancella quando vuoi.",
    priceLabel: "€9,90",
    pricePeriod: "/mese",
    noAutoCharge: "Senza carta e senza addebiti automatici",
    bullets: {
      firstToday: "Primo addebito oggi, poi €9,90/mese",
      cancelAnytime: "Cancella con un click, accesso fino a fine periodo",
      secureStripe: "Pagamento sicuro tramite Stripe",
    },
    ctaSubscribe: "Abbonati a 9,90 € / mese",
    cancelAnytime: "Puoi cancellare in qualsiasi momento",
    firstChargeNote: "Primo addebito oggi, poi €9,90 al mese. Puoi cancellare quando vuoi.",
    cancelBtn: "Cancella abbonamento",
    cancelConfirmTitle: "Confermi l'annullamento?",
    cancelConfirmBody: "Potrai utilizzare l'app fino alla fine del periodo corrente.",
    toast: {
      redirecting: "Reindirizzo su Stripe…",
      canceled: "Abbonamento annullato.",
      genericError: "Si è verificato un errore. Riprova tra qualche istante.",
    },
    adminDisabled: "Il tuo account è stato disabilitato. Contatta l'assistenza.",
    reasonTrialUsed: "Hai già utilizzato la prova gratuita con questa email.",
    reasonTrialExpired: "La tua prova gratuita è terminata.",
  },
  subscribeSuccess: {
    title: "Grazie!",
    bodyActive: "Il tuo abbonamento è ora attivo.",
    bodyTrial: "La tua prova gratuita è stata attivata.",
    goDashboard: "Vai alla dashboard",
    verifying: "Stiamo verificando il pagamento…",
  },
  subscribeCancel: {
    title: "Pagamento annullato",
    body: "Nessun addebito è stato effettuato. Puoi riprovare quando vuoi.",
    retry: "Riprova",
    toSubscribe: "Torna agli abbonamenti",
  },
  shell: {
    statusTrial: "Prova · fino al {date}",
    statusFreeTrial: "Prova gratuita · fino al {date}",
    statusCancelAt: "Cancella il {date}",
    statusActive: "Abbonato",
    statusPastDue: "Pagamento in sospeso",
    statusGenericActive: "Attivo",
  },
  editor: {
    subtitleEmpty: "nessun template caricato",
    step1: "01 · Template",
    step1Title: "Carica il primo PDF",
    dropHereCta: "Trascina o clicca",
    dropHereHint: "Un PDF di riferimento",
    processing: "Elaborazione...",
    step2: "02 · Cartella Input",
    step2Title: "PDF da compilare",
    dropFolderCta: "Trascina la cartella",
    dropFolderHint: "o seleziona più PDF",
    filesSelected: "{n} file selezionati",
    step3: "03 · Elaborazione",
    step3Title: "Cartella Output",
    outputFolderHint: "Scegli una cartella sul PC; verrà creata la sottocartella {name}-output e i PDF verranno sovrascritti.",
    outputFolderHintZip: "Il tuo browser non supporta il salvataggio diretto. Verrà scaricato uno ZIP.",
    emptyCanvasTitle: "Carica un PDF di riferimento per iniziare",
    emptyCanvasBody: "Clicca sul PDF per posizionare i campi. Ogni campo verrà replicato identicamente su tutti i PDF della cartella input.",
    pageIndicator: "Pagina {current} / {total}",
    canvasMeta: "{w} × {h} pt · anteprima {pw}×{ph}px",
    rightTitle: "Lista campi",
    rightSub: "Posizionamento",
    noFieldsHint: "Clicca sul PDF per aggiungere un campo",
    emptyField: "(vuoto)",
    editField: "Modifica campo",
    textLabel: "Testo",
    fontSizeLabel: "Dimensione font (px anteprima)",
    deleteField: "Elimina campo",
    defaultText: "Testo",
    toasts: {
      templateLoaded: "Template caricato: {n} pagina/e",
      archiveDownloaded: "Archivio scaricato ({n} PDF)",
      savedInFolder: "{n} PDF salvati in {folder}/",
      needPdfs: "Aggiungi almeno un PDF alla cartella input",
      needFields: "Aggiungi almeno un campo sul template",
    },
  },
  csvBatch: {
    subtitleEmpty: "carica un template PDF",
    step1: "01 · Template PDF",
    step1Title: "Carica riferimento",
    dropCta: "Trascina o clicca",
    step2: "02 · CSV dati",
    step2Title: "File CSV",
    selectCsv: "Seleziona CSV",
    oneRowOnePdf: "1 riga = 1 PDF generato",
    columnsLabel: "Colonne (clicca per assegnare al campo selezionato)",
    columnUsedTip: "Colonna già usata da un campo",
    columnFreeTip: "Colonna disponibile",
    columnsSummary: "{used}/{total} colonne mappate · {rows}+ righe",
    step3: "03 · Elabora",
    processHint: "Ogni riga del CSV → un PDF. I placeholder {ph} vengono sostituiti.",
    subfolder: "Sottocartella: {name}.",
    emptyCanvasTitle: "Carica il PDF template",
    emptyCanvasBody: "Posiziona i campi come segnaposto {ph}. Ogni riga del CSV genererà un PDF distinto.",
    pageIndicator: "Pagina {current} / {total}",
    rightTitle: "Lista campi",
    rightSub: "Posizionamento",
    noFieldsHint: "Clicca sul PDF per aggiungere un campo",
    emptyField: "(vuoto)",
    editField: "Modifica campo",
    textWithCol: "Testo (usa {colph})",
    fontSizeLabel: "Font size (px)",
    deleteField: "Elimina campo",
    defaultText: "Testo",
    toasts: {
      templateLoaded: "Template caricato: {n} pagina/e",
      csvLoaded: "CSV caricato: {n} colonne",
      needTemplate: "Carica il template PDF",
      needCsv: "Carica il CSV",
      needField: "Aggiungi almeno un campo",
      selectFieldFirst: "Seleziona prima un campo (clicca sul PDF o su un campo nella lista)",
      savedInFolder: "{n} PDF salvati in {folder}/",
    },
  },
  acroform: {
    subtitleEmpty: "carica un PDF con campi modulo",
    step1: "01 · PDF di riferimento",
    step1Title: "Rilevamento campi",
    analyzing: "Analisi…",
    uploadFillable: "Carica PDF fillable",
    noForm: "Questo PDF non contiene campi modulo AcroForm. Passa alla modalità Batch identico.",
    step2: "02 · Cartella Input",
    step2Title: "PDF da compilare",
    dropCta: "Trascina o seleziona",
    sameNameFill: "Compilerò i campi con lo stesso nome",
    filesCount: "{n} file",
    step3: "03 · Elaborazione",
    subfolderHint: "Sottocartella: {name}. I file esistenti verranno sovrascritti.",
    emptyTitle: "Compila i campi modulo del PDF",
    emptyBody: "Carica un PDF con campi AcroForm (moduli compilabili) per rilevare automaticamente i nomi dei campi. Poi applica gli stessi valori a tutti i PDF con struttura identica.",
    fieldsDetected: "{n} campi rilevati",
    valuesTitle: "Valori da applicare",
    fieldMeta: "{type} · pag {page}",
    toasts: {
      detected: "{n} campi modulo rilevati",
      noForm: "Nessun campo modulo (AcroForm) rilevato in questo PDF",
      needPdfs: "Aggiungi almeno un PDF alla cartella input",
      needValue: "Compila almeno un valore",
      savedInFolder: "{n} PDF salvati in {folder}/",
      archiveDownloaded: "Archivio scaricato ({n} PDF)",
    },
  },
  templates: {
    title: "Template salvati",
    namePlaceholder: "Nome template",
    loading: "caricamento…",
    empty: "Nessun template salvato",
    fieldsCount: "{n} campi",
    confirmDelete: "Eliminare il template?",
    toasts: {
      nameRequired: "Inserisci un nome",
      cannotSave: "Carica un template e aggiungi almeno un campo",
      saved: "Template salvato",
      deleted: "Template eliminato",
      loaded: "Caricato: {name}",
    },
  },
  admin: {
    title: "Super admin · utenti",
    refresh: "aggiorna",
    auditLog: "Audit log",
    wipeAntifraud: "Azzera antifrode",
    cols: {
      email: "Email",
      name: "Nome",
      role: "Ruolo",
      status: "Stato",
      payment: "Pagamento",
      trial: "Periodo di prova",
      createdAt: "Creato il",
      actions: "Azioni",
    },
    active: "attivo",
    inactive: "disattivo",
    delete: "Elimina",
    confirmDeleteTitle: "Eliminare l'account?",
    confirmDeleteBody: "L'account verrà rimosso. Questa azione non può essere annullata.",
    wipe: {
      dialogTitle: "Azzera antifrode per una email",
      dialogDesc: "Questa operazione cancella il record dello storico antifrode email_trial_state per la singola email indicata.",
      newTrial: "Alla prossima registrazione l'utente riceverà una nuova prova gratuita di 7 giorni.",
      warning: "Attenzione: l'account applicativo deve essere stato già eliminato dalla lista utenti. Altrimenti l'operazione viene rifiutata (409).",
      emailLabel: "Email target",
      phraseLabel: "Conferma: scrivi {phrase}",
      confirmBtn: "Azzera antifrode",
      busy: "Azzeramento…",
      successDeleted: "Antifrode azzerato per {email}. Potrà ricevere una nuova prova di 7 giorni.",
      successNoop: "Nessun record antifrode trovato per {email}.",
    },
    audit: {
      title: "Audit log super-admin",
      subtitle: "Ultime {n} operazioni caricate.",
      empty: "Nessuna operazione registrata.",
      loading: "caricamento…",
      actionDeleteUser: "elimina utente",
      actionWipeAntifraud: "azzera antifrode",
    },
  },
  errors: {
    network: "Problema di connessione. Riprova.",
    unknown: "Si è verificato un errore. Riprova.",
    serverBusy: "Servizio non disponibile al momento. Riprova tra poco.",
    invalidCredentials: "Credenziali non valide.",
    emailExists: "Esiste già un account con questa email. Accedi o recupera la password.",
    emailInvalid: "Email non valida.",
    passwordWeak: "Password troppo corta (minimo 6 caratteri).",
    trialNotAvailable: "Hai già utilizzato la prova gratuita con questa email.",
    requireAuth: "Devi accedere per continuare.",
    accessBlocked: "Il tuo accesso è limitato. Abbonati per continuare a usare l'app.",
    tooManyAttempts: "Troppi tentativi. Attendi prima di riprovare.",
  },
};
